import { marked } from 'marked';

function setupLinkRender() {
  const linkRenderer = new marked.Renderer();
  linkRenderer.link = function (href: string, title: string, text: string) {
    let external = true,
      newWindow,
      out;

    // We are using parent bacause we are in a iframe.
    const location = window.location;
    if (location.origin === 'undefined' || location.origin === 'null') {
      (location as any).origin = location.protocol + '//' + location.host;
    }

    if (href.indexOf(location.origin) > -1) {
      external = false;
    }

    if (external === true || title === 'newWindow') {
      newWindow = true;
    }

    out = '<a href="' + href + '"';
    if (newWindow) {
      out += ' rel="noopener noreferrer"';
      out += ' target="_blank"';
    }
    if (title && title !== 'newWindow') {
      out += ' title="' + title + '"';
    }
    out += '>' + text + '</a>';
    return out;
  };

  return linkRenderer;
}

marked.setOptions({
  renderer: setupLinkRender(),
  gfm: true,
  breaks: true,
  mangle: false,
});

export function preprocessMarkdown(md: string): string {
  // To find lines that start with four spaces but should not form a code block <code> that is intervening html rendering
  return md.replace(/^( {4})+/gm, (match) => match.replace(/ {4}/g, ''));
}

export default function markdownToHTML(markdown: string): string {
  const processedMarkdown = preprocessMarkdown(markdown);

  return marked(processedMarkdown).trim();
}
